import _ from 'underscore';
import templateStr from 'text!./payroll.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {},
        controller: ['$filter', '$rootScope', '$scope', 'policy.PolicyService', '$stateParams', '$state', '$q', function ($filter, $rootScope, $scope, PolicyService, $stateParams, $state, $q) {
            $scope.init = function () {
                $scope.payrollDataEmpty = false;
                $scope.editIsVisible = false;
                $scope.policyNumber = $stateParams.policyNumber;
                $scope.termList = [];
                $scope.scheduledReports = null;
                requestAllPolicyTerms();

                $scope.isAudit = true;
                /**
                * Function call that allows navigation to Payroll data view.
                * @params{Object} - payroll item
                * @returns{void}
                * @private
                **/
                $scope.payrollData = function (item) {
                    $state.go('payroll-data', {
                        data: item,
                        startDate: $scope.startDate,
                        endDate: $scope.endDate,
                        jobNumber: $scope.jobNumber
                    });
                };
            }; //End of init()

            $scope.init();

            /**
             * Retrieve all Policy Terms
             * Updates the account display in the drop down list of the main page.
             * @params : None
             * @returns {Object} data - list of accounts
             **/
            function requestAllPayrollsForTerm(selectedTerm) {
                return PolicyService.payrollReportingForPolicyTerm($stateParams.policyNumber, selectedTerm).then(function (res) {
                    if (res.auditReports) {
                        angular.forEach(res.auditReports, function (auditRes) {
                            if (auditRes.status == "Completed") $scope.isScheduledAudit = true;else $scope.isScheduledAudit = false;
                        });
                    }
                    if (res.scheduledReports) {
                        $scope.disableLoader = false;
                        var completedArrayIndex = -1;
                        $scope.scheduledArray = [];
                        $scope.inProgressArrayIndex = -1;
                        angular.forEach(res.scheduledReports, function (result, skey) {
                            //ACR 18624 - modifiying period end date for display purposes only
                            var dateStr = result.endDate;
                            var date = new Date(dateStr);
                            date.setDate(date.getDate() - 1);
                            var newDateStr = date.toISOString();
                            result.endDate = newDateStr;

                            if (result.canReverse == true) {
                                if (result.status == 'Completed') $scope.scheduledArray.push(result);
                            }
                            if (result.canReverse == false) {
                                if (result.status == 'Scheduled' || result.status == 'In Progress') {
                                    if ($scope.inProgressArrayIndex == -1 && result.status == 'In Progress') findInprogress($scope.scheduledArray, result);
                                    $scope.scheduledArray.push(result);
                                }
                            }
                        });
                    }
                    $scope.scheduledReports = $scope.scheduledArray;
                    if (res.auditCompletedReports) {
                        angular.forEach(res.auditCompletedReports, function (auditCompRes) {
                            if (auditCompRes.status == "Completed") $scope.isCompletedAudit = true;else $scope.isCompletedAudit = false;
                        });
                    }
                    $scope.startDate = res.periodStart;
                    $scope.endDate = res.endDate;
                    $scope.jobNumber = res.jobNumber;
                    if (res.scheduledReports == undefined || res.scheduledReports.length == 0) {
                        $scope.scheduledReportsEmpty = true;
                    } else {
                        $scope.scheduledReportsEmpty = false;
                    }
                }, function () {
                    $scope.scheduledReports = null;
                });
            } // End of requestAllPayrollsForTerm function

            /**
             * Function to identify reports that are in progress
             * @params{Object, Object} - scheduledReports, result
             * @returns{int} - inProgressArrayIndex number
             **/
            function findInprogress(scheduledReports, result) {
                var srIndeex = scheduledReports.length - 1;
                if (srIndeex > -1 && scheduledReports[srIndeex].status == 'Completed' && result.status == 'In Progress') {
                    $scope.inProgressArrayIndex = srIndeex + 1;
                } else if (srIndeex == -1 && result.status == 'In Progress') {
                    $scope.inProgressArrayIndex = srIndeex + 1;
                }
            }

            /**
            * Function for navigating to the policy detail summary screen
            * @params{void}
            * @returns{void}
            **/
            $scope.policysummaryForm = function () {
                $state.go('policies.detail.summary', {
                    policyNumber: $stateParams.policyNumber
                });
            };

            /**
             * Function to open the payroll detail entry form if form is not open
             * @params{String} - jobNumber
             * @returns{void}
             * @private
            **/
            $scope.showEnterPayrollForm = function (jobNumber, startDate, endDate) {
                $scope.withdrawSubmitted = false;
                if ($scope.formIsOpen) {
                    return;
                }
                $scope.formIsOpen = true;
                $state.go('enterpayroll-details', {
                    jobNumber: jobNumber,
                    startDate: startDate,
                    endDate: endDate
                });
            }; //End of showEnterPayrollForm

            /**
            * Function to edit payroll details entry form if form is not open
            * @params{String, Object} - jobNumber, item
            * @returns{void}
            * @private
             **/
            $scope.editEnterPayrollForm = function (jobNumber, item, viewOnly) {
                $scope.withdrawSubmitted = false;
                if ($scope.formIsOpen) {
                    return;
                }
                $scope.formIsOpen = true;
                item.disableSubmit = true;
                $state.go('editpayroll-details', {
                    jobNumber: jobNumber,
                    startDate: $scope.startDate,
                    endDate: $scope.endDate,
                    viewOnly: viewOnly
                });
            }; //End of edit payroll form

            /**
             * Retrieve all Policy Terms
             * Updates the account display in the drop down list of the main page.
             * @params : None
             * @returns {Object} data - list of accounts
             **/
            function requestAllPolicyTerms() {
                return PolicyService.getPolicyTerms($stateParams.policyNumber).then(function (data) {
                    $scope.allPolicyTerms = $filter('orderBy')(data, '-periodStart');
                    if ($rootScope.selectedTermNumber !== undefined && $rootScope.selectedTermNumber !== null) {
                        $scope.policyTermListMod = parseInt($rootScope.selectedTermNumber);
                    } else if ($scope.allPolicyTerms[0].length !== 0) {
                        $scope.policyTermListMod = $scope.allPolicyTerms[0].termNumber;
                        var inProgressTermNumber = "";
                        var policyStartDate = "";
                        $scope.allPolicyTerms.forEach(function (term) {
                            if (term.isInProgressPayrolls) {
                                if (policyStartDate) {
                                    if (term.periodStart < policyStartDate) {
                                        policyStartDate = term.periodStart;
                                        inProgressTermNumber = term.termNumber;
                                    }
                                } else {
                                    policyStartDate = term.periodStart;
                                    inProgressTermNumber = term.termNumber;
                                }
                            }
                        });
                        if (inProgressTermNumber) {
                            $scope.policyTermListMod = inProgressTermNumber;
                        }
                    } else {
                        $scope.payrollLoadedPromise = "Nothing";
                    }
                    /** Populate the drop down **/
                    $scope.allPolicyTerms.forEach(function (term) {
                        $scope.termList.push({ 'periodStart': term.periodStart, 'periodEnd': term.periodEnd, 'termNumber': term.termNumber, 'status': term.status });
                    });
                    return data;
                }, function () {
                    // Error while retrieval...
                });
            }
            /**
             * Update and refresh accounts information when selection is changed
             * @params {String, String | oldAccount, newAccount}
             * @returns Updated landingLoadedPromise on Scope object
             **/
            $scope.$watch('policyTermListMod', function (newValue, oldValue) {
                if (newValue !== oldValue) {
                    $rootScope.selectedTermNumber = $scope.policyTermListMod;
                    $scope.scheduledReports = requestAllPayrollsForTerm($scope.policyTermListMod);
                    $scope.payrollLoadedPromise = $q.all([$scope.scheduledReports]);
                }
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/PayrollDirective_MSF/Payroll.js
// module id = 1752
// module chunks = 0